/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Extract_Select_Video_LabelInputs */



/**
* | output |
* | --- |
* | "Video file (MOV, MP4, MXF, MPEG-TS or MPEG-PS)" |
*
* @param {Subtitle_Extract_Select_Video_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_select_video_label = /** @type {((inputs?: Subtitle_Extract_Select_Video_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_Select_Video_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichier vidéo (MOV, MP4, MXF, MPEG-TS ou MPEG-PS)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videodatei (MOV, MP4, MXF, MPEG-TS oder MPEG-PS)")
	if (locale === "it") return /** @type {LocalizedString} */ ("File video (MOV, MP4, MXF, MPEG-TS o MPEG-PS)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видеофайл (MOV, MP4, MXF, MPEG-TS или MPEG-PS)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivo de vídeo (MOV, MP4, MXF, MPEG-TS o MPEG-PS)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频文件（MOV、MP4、MXF、MPEG-TS 或 MPEG-PS）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("動画ファイル（MOV、MP4、MXF、MPEG-TS、またはMPEG-PS）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो फ़ाइल (MOV, MP4, MXF, MPEG-TS या MPEG-PS)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivo de vídeo (MOV, MP4, MXF, MPEG-TS ou MPEG-PS)")
	return /** @type {LocalizedString} */ ("Video file (MOV, MP4, MXF, MPEG-TS or MPEG-PS)")
});